import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { scrollToSection } from "@/lib/scroll";

const CTA = () => {
  return (
    <section data-testid="cta-section" className="relative mx-auto max-w-[1440px] px-6 py-16 md:px-12">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2.5rem] border border-white/10 px-8 py-16 text-center md:px-16 md:py-24">
          {/* gradient glow background */}
          <div
            className="glow-orb h-[360px] w-[520px] animate-pulse-glow"
            style={{ top: "-8rem", left: "10%", background: "#22d3ee", opacity: 0.35 }}
            aria-hidden
          />
          <div
            className="glow-orb h-[360px] w-[520px] animate-pulse-glow"
            style={{ bottom: "-9rem", right: "10%", background: "#a855f7", opacity: 0.35, animationDelay: "2s" }}
            aria-hidden
          />
          <div className="absolute inset-0 bg-grid opacity-60" aria-hidden />

          <div className="relative">
            <h2 className="mx-auto max-w-3xl font-heading text-4xl font-semibold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
              Ready to build a website that{" "}
              <span className="text-gradient">works for your business?</span>
            </h2>
            <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-white/60 md:text-lg">
              Let's turn your online presence into your hardest-working asset. Tell us
              about your project and get a free, no-obligation quote.
            </p>
            <motion.button
              whileHover={{ scale: 1.04 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => scrollToSection("contact")}
              data-testid="cta-start-button"
              className="group mx-auto mt-9 flex items-center gap-2 rounded-full bg-white px-8 py-4 text-sm font-semibold text-black"
            >
              Start Your Project
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </motion.button>
          </div>
        </div>
      </Reveal>
    </section>
  );
};

export default CTA;
